import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { callSidFunction, getSourceValue, setCookie } from '../../lib/common';
import { handleLoginPopup } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';

function LoginErrorPopup({ desc, login, redirect }) {
  const source = getSourceValue();
  const navigate = useNavigate();
  const [appState, appDispatch] = useAppState();
  const handleCsPortalSidCheck = async () => {
    await callSidFunction(source || 2);
  };

  const handleLoginredirection = () => {
    document.body.style.overflow = 'unset';
    window.localStorage.clear();
    window.sessionStorage.clear();
    setCookie('mobile', '');
    handleCsPortalSidCheck();
  };

  const handleClosePopup = () => {
    document.body.style.overflow = 'unset';
    handleLoginPopup(appDispatch, {
      ...appState.loginPopup,
      open: false,
      click: false,
      redirect: false,
      nonLoginGrievancePopup: '',
    });
  };

  const handleCsHomeRedirect = () => {
    if (appState?.loginPopup?.nonLoginGrievancePopup) {
      handleClosePopup();
      return;
    }
    if (appState?.validatorPopup?.individual) {
      handleClosePopup();
      navigate('/csportal', { replace: true });
      return;
    }
    navigate(-1);
    handleClosePopup();
  };

  const loginYesClass = 'login_yes colorFFF';
  const loginNoClass = 'login_no color007 mr-10';
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);
  return (
    <section className="cs_modal cs_slbusiness_pop dt">
      <div className="cs_modal_content cs_modal_animation cs_modal_up">
        <div className="cs_modal_body">
          <div className="pop_slbusiness_header">
            <div className="slbusiness_headtxt font14  color1A1 pt-25 pl-20 pr-20">
              {desc || 'Please login to register a complaint.'}
            </div>
          </div>

          <div className="pl-20 pr-20 pt-20 pb-30">
            <button
              onClick={handleCsHomeRedirect}
              type="button"
              className={`font15 ${login ? loginNoClass : loginYesClass}`}
            >
              {redirect ? 'Go back' : 'Close'}
            </button>
            {login && (
              <button onClick={handleLoginredirection} type="button" className={`font15 ${loginYesClass}`}>
                Login
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

LoginErrorPopup.propTypes = {
  desc: PropTypes.string,
  login: PropTypes.bool,
  redirect: PropTypes.bool,
};

LoginErrorPopup.defaultProps = {
  desc: 'Please login with the registered mobile number!',
  login: true,
  redirect: false,
};

export default LoginErrorPopup;
